import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";

import back from "../../back.png";

import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputCombo from "../../helpers/InputCombo";
import InputPhone from "../../helpers/InputPhone";
 


function ServiceRedirectForm(props)
{

      const [checked1, setChecked1] = useState(false);
      const handleChange1= () => {
          setChecked1(!checked1);
      };  


    const [errTab, setErrTab] = useState([]); 


    const [row, setRow] = useState({


        id: '-1',

        uslugi_id: props.uslugi_id,    
        nazwa: '',    
        telefon: '',    
        is_active: '1',     
    });
    var tmpRow = row;


        
    const valChangeListener = (filedName, val, correct, msg) => {   
        
 
               // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
           
            
                tmpRow[filedName] = val;
                tmpRow[filedName+"_valid"] = correct;         
 
                setRow(  JSON.parse(JSON.stringify(tmpRow)) );    
            
                //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );                          
 

            }   
        
        
    const goNextNew = () => {
                console.log("goNext");               
            }



   const valChecker = (fields) => {

        var allValid = true;

              
        console.log(JSON.stringify(fields) );

        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                if(Config.env == 'dev') console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }

    
    const saveData = () => {
        

        if(!valChecker(row))
        {
                props.mainView.showDialog("Ups!" , "Wypełnij prawidłowo pola formularza"  ,  "error"  ,null); 
                return;
        }

        props.mainView.showProgress();
         

        fetch( Config.url + '/rest_v1_home,redirect_set', {
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

             
                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                         props.mainView.showDialog( "Sukces",  "Dane zostały zapisane.", "ok" , (pp)=>{
                                if(props.onSuccess != undefined) props.onSuccess(res.result);         
                         } );                                                  
                                                      
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }





    const getRedirectDet = (idF) => {
        

        props.mainView.showProgress();
         

        fetch( Config.url + '/rest_v1_home,redirect_det', {
            method: 'POST', 
            body: JSON.stringify( { id: idF}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                
                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setRow(res.result);                                                 
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }



        const keyListener = (e) => {

                       var code = e.keyCode ? e.keyCode : e.which;    

                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {
                                e.target.blur();
                        }else
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                        {                                         
                        }else  
                        if(e.target.nodeName.toLowerCase() == "body" && code == 8 )                                                  
                        {
                                props.onBack();                               
                        } else
                        if( e.ctrlKey && code == 83 )   //zapisz                                               
                                {
                                       saveData();
                                       e.preventDefault();
                                } else 
                        {
                            props.keyListener(e);
                        }


    }


     useEffect(() => {
        
                if(props.id > 0 && row.id == -1)
                {
                    getRedirectDet( props.id );
                }

            

                if(Config.env == "dev") console.log("ServiceRedirectForm.js, listener on");
                window.onkeydown = keyListener;

                return () => {          
                    if(Config.env == "dev") console.log("ServiceRedirectForm.js, listener off");      
                    window.onkeydown = props.keyListener;
                };

      });



    return  <div className="view_content">       
                <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>   

                        <h3 className="dash_header"> 
                                         {props.umowa.numer_umowy} / 
                                         &nbsp; {props.usluga.nazwa_uslugi} / Nowe przekierowanie
                         </h3>


                        <div className="form_tab">
            

                            <form className="eForm bg_center">

                                 <div className="form_control">
                                                <div className="fieldName">Nazwa*</div>
                                                <InputText   userData={props.userData} value={row.nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nazwa" placeholder={"Nazwa:"} className=' w200 ' req='1' firstUp="1" />
                                </div>

                                 <div className="form_control">
                                                <div className="fieldName">Telefon*</div>
                                                <InputPhone   userData={props.userData} value={row.telefon} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="telefon" placeholder={"Telefon:"} className=' w200 '  />
                                </div>

                                 <div className="form_control">
                                                <div className="fieldName">Aktywne*</div>
                                                <InputCombo  items={  [ {v:'0',title:'Nie'},  {v:'1',title:'Tak'},    ] }  userData={props.userData} value={row.is_active} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="is_active" placeholder={":"} className=' w200 '   />
                                </div>

 
                                <div className="form_split"></div>

                                <div className="form_btn">
                                                        
                                        <div className="btn" onClick={saveData}>zapisz zmiany [cntr+s]</div>
                                             &nbsp;&nbsp;
                                        <div className="btn" onClick={props.onBack}    > anuluj [back]</div>
                                </div>


                            </form>



                        </div>
            </div>

}


export default ServiceRedirectForm;